<script lang="ts">
  import CategoryFilterBar from "$lib/design-systems/marketing/primitives/legacy-v1/CategoryFilterBar.svelte";
  import ExampleCardLink from "$lib/design-systems/marketing/primitives/legacy-v1/ExampleCardLink.svelte";
  import {
    type FeaturedExample,
    getExampleImage,
    getFeaturedExamples,
  } from "$lib/docs/featured-examples";

  type Category = (typeof categories)[number];

  let filteredExamples: FeaturedExample[];
  const categories: Record<string, string> = {
    featured: "Featured",
    "use-case-image-video-3d": "Images, video & 3D",
    "use-case-finetuning": "Fine-tuning",
    "use-case-lm-inference": "Language modeling",
    "use-case-job-queues-batch": "Batch processing",
    "use-case-audio-inference": "Audio",
    "use-case-sandboxed-code-execution": "Modal Sandboxes",
    "use-case-comp-bio": "Computational biology",
  };

  let selectedCategory: Category = "featured";
  $: filteredExamples = getFeaturedExamples(selectedCategory);
</script>

<div
  class="max-w-(--breakpoint-xl) col-span-2 mx-auto mb-8 mt-12 flex w-full flex-col gap-12"
>
  <div class="flex flex-col gap-12">
    <div class="flex flex-col gap-6">
      <h3 class="text-light-green marketing-h3">Featured Examples</h3>
      <CategoryFilterBar
        categories={Object.values(categories)}
        selectedCategory={categories[selectedCategory]}
        updateCategory={(category) => {
          selectedCategory =
            Object.keys(categories).find(
              (key) => categories[key] === category,
            ) || "featured";
        }}
      />
    </div>
    <div
      class="grid gap-x-4 gap-y-4 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4"
    >
      {#each filteredExamples as example}
        <ExampleCardLink
          href={`/docs/examples/${example.stem}`}
          image={getExampleImage(example)}
          title={example.title}
          description={example.description}
        />
      {/each}
    </div>
  </div>
</div>
